if ($('#job-notification-setting').length > 0) {
    $(() => {
        const reloadMessage =
            'エラーが発生しました。お手数ですがページの再読み込み（リロード）をお試しくださいませ。';
        new Vue({
            el: '#job-notification-setting',
            data: {
                vapidPublicKey: '',
                csrfToken: '',
                registration: null,
                isSubscribed: false,
                subscription: null,
                processing: false,
                initialized: false,
                pushable: false,
            },
            methods: {
                subscribe() {
                    // プッシュ通知を許可する

                    if (!this.pushable || this.isSubscribed) {
                        return;
                    }

                    this.processing = true;
                    const applicationServerKey = this.base64toUint8(this.vapidPublicKey);
                    const options = {
                        userVisibleOnly: true,
                        applicationServerKey: applicationServerKey,
                    };
                    this.registration.pushManager
                        .subscribe(options)
                        .then((subscription) => {
                            // Laravel側へデータを送信
                            fetch('/mypage/web-notification', {
                                method: 'POST',
                                body: JSON.stringify(subscription),
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    'X-CSRF-Token': this.csrfToken,
                                },
                            })
                                .then((response) => {
                                    if (!response.ok) {
                                        // error
                                        console.log(response);
                                        subscription.unsubscribe().then();
                                        alert(reloadMessage);
                                        return;
                                    }

                                    this.isSubscribed = true;
                                    this.subscription = subscription;
                                    // alert('プッシュ通知が登録されました');
                                })
                                .catch((error) => {
                                    console.log(error);
                                    subscription.unsubscribe().then();
                                    alert(reloadMessage);
                                })
                                .finally(() => {
                                    this.processing = false;
                                });
                        })
                        .catch((error) => {
                            console.log(error);
                            alert('プッシュ通知を設定できませんでした。ブラウザーの設定でブロックしている場合は許可に設定を変更してください。');
                            this.processing = false;
                        });
                },
                unsubscribe() {
                    // プッシュ通知を解除する

                    if (!this.pushable || !this.isSubscribed) {
                        return;
                    }

                    this.processing = true;

                    // Laravel側へデータを送信
                    fetch('/mypage/web-notification', {
                        method: 'DELETE',
                        body: JSON.stringify(this.subscription),
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'X-CSRF-Token': this.csrfToken,
                        },
                    })
                        .then((response) => {
                            if (!response.ok) {
                                // error
                                console.log(response);
                                alert(reloadMessage);
                                this.processing = false;
                                return;
                            }

                            this.subscription
                                .unsubscribe()
                                .then((result) => {
                                    if (result) {
                                        this.isSubscribed = false;
                                        this.subscription = null;
                                        // alert('プッシュ通知が解除されました');
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                    alert(reloadMessage);
                                })
                                .finally(() => {
                                    this.processing = false;
                                });
                        })
                        .catch((error) => {
                            console.log(error);
                            alert(reloadMessage);
                            this.processing = false;
                        });
                },
                base64toUint8(str) {
                    str += '='.repeat((4 - (str.length % 4)) % 4);
                    const base64 = str
                        .replace(new RegExp('-', 'g'), '+')
                        .replace(new RegExp('_', 'g'), '/');

                    const binary = window.atob(base64);
                    const binaryLength = binary.length;
                    let uint8Array = new Uint8Array(binaryLength);

                    for (let i = 0; i < binaryLength; i++) {
                        uint8Array[i] = binary.charCodeAt(i);
                    }

                    return uint8Array.buffer;
                },
            },
            mounted() {
                this.vapidPublicKey = this.$el.dataset.vapidPublicKey;
                this.csrfToken = this.$el.dataset.csrfToken;
                document.getElementById('job-notification-setting-initial').style.display = 'none';
                document.getElementById('job-notification-setting-mounted').style.display = 'block';

                if ('serviceWorker' in navigator && 'PushManager' in window) {
                    // Service Workerをブラウザにインストールする
                    navigator.serviceWorker.register('/sw.js').then((registration) => {
                        console.log('Service Worker が登録されました。');
                        this.registration = registration;
                        this.registration.pushManager
                            .getSubscription()
                            .then((subscription) => {
                                this.isSubscribed = !(subscription === null);
                                this.subscription = subscription;
                                this.pushable = true;
                            })
                            .catch()
                            .finally(() => {
                                this.initialized = true;
                            });
                    });
                } else {
                    console.log('このブラウザは、プッシュ通知をサポートしていません。');
                    this.initialized = true;
                }
            },
        });
    });
}
